
















import Component from 'vue-class-component';
import Vue from 'vue';
import OfficeProgressChartCriteria from './office-progress-chart-criteria.vue';
import OfficeChart from '@/components/stats/office-chart.vue';
import * as ent from '@/entities';
import statsApi from '@/api/stats.api';

@Component({
    components: {
        'office-progress-chart-criteria': OfficeProgressChartCriteria,
        'office-chart': OfficeChart
    }
})
export default class OfficeProgressChart extends Vue {
    public items: ent.IStatsOfficePeriodChartModel[] = null;
    public loading: boolean = false;
    public criteria: ent.IGetOfficePeriodsChartModel = null;


    public criteriaChange(body: ent.IGetOfficePeriodsChartModel) {
        this.criteria = body;
        this.search();
    }

    public async search() {
        if (!this.criteria) {
            return;
        }
        this.loading = true;
        try {
            this.items = await statsApi.officeCharts(this.criteria);
        } finally {
            this.loading = false;
        }
    }
}
